import React from 'react';
import CommonTitle from '../../../containers/Reservation/component/common-title';
import ButtonList from '../button/button-list';

function CustomAccordion(props) {
    const { title, isActive, setIsActive, btnList, titleClass, titleClick, iconClasses = "text-right" } = props;
    const onAccordionClick = () => {
        setIsActive(!isActive)
    }
    return (
        <div onClick={() => { !btnList && onAccordionClick() }} className='flex-row cursor-pointer' >
            <div className='flex-row gap-1'>
                {title ? <CommonTitle title={title} classNames={titleClass || "common-title"}
                    titleClick={titleClick ? titleClick : btnList ? onAccordionClick : null}
                /> : ""}
                {btnList && <ButtonList btnList={btnList} />}
            </div>
            <i
                onClick={() => btnList && onAccordionClick()}
                className={` ${isActive
                    ? "fa fa-angle-up"
                    : "fa fa-angle-down"
                    }  fs-8 flex-1 ${iconClasses}`}
            ></i>
        </div >
    )
}

export default CustomAccordion